import { type Control } from 'react-hook-form'

import { FormControl, FormField, FormItem, FormLabel, FormMessage, Textarea } from '@/shared'

import { type TransactionFormValues } from './transaction-form'

interface Props {
    control: Control<TransactionFormValues>
}

export const TransactionFormNotes = ({ control }: Props) => {
    return (
        <FormField
            control={control}
            name="notes"
            render={({ field }) => (
                <FormItem>
                    <FormLabel>Notes</FormLabel>
                    <FormControl>
                        <Textarea {...field} className="resize-none" placeholder="Add notes here..." rows={7} />
                    </FormControl>
                    <FormMessage />
                </FormItem>
            )}
        />
    )
}
